import React from 'react';
import {useLocation, Navigate, Outlet} from 'react-router-dom';
import {getUserRole, getUsername} from '../helpers/localStorage';
// Outlet will apply the useAuth to all child routes (aka the whole app)

// adding the state of 'from' lets us know where we came from and adds to browser history
// this lets user go back to screen they were on if unauthorized, or automatically redirect if logged in

// Check if current auth role is in the roles allowed for the route in routes.js
// If not, check if they are logged in.  If they're logged in they're unauthorized, otherwise redirect to login
const RequireAuth = ({allowedRoles}) => {
  const location = useLocation();
  const roles = getUserRole();
  const username = getUsername();

  // If any of the user's permissions are in the allowed roles array they are free to proceed
  if (allowedRoles?.some(role => roles?.includes(role))) {
    return <Outlet />;
  } else if (username != null) {
    return <Navigate to="/unauthorized" state={{from: location}} replace />;
  } else {
    return <Navigate to="/login" state={{from: location}} replace />;
  }
};

export default RequireAuth;
